export default {"src":"/hedera/_next/static/media/immunifi.518ae1a9.svg","height":20,"width":21};